export default __webpack_public_path__ + "static/media/edital-21-2021-rfp.970c543c.pdf";